import { PasswordField, PasswordFieldProps } from '@components/password-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormPasswordFieldProps<T> = FormFieldProps<PasswordFieldProps, T>;

export function FormPasswordField<T>(props: FormPasswordFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <PasswordField {...props} {...formFieldProps} />;
}
